import { CuraIcon, CuraLabel } from '@rededor/cura-react'
import * as S from './styles'

import { useChatButton } from './useChatButton'
import { useChatStore } from '@/store/useChatStore'

type Props = {
  isMobile: boolean
  isOpening?: boolean
}

export const ChatButton = ({ isMobile, isOpening = false }: Props) => {
  const { calculateOffset, sendEventOpenChatMixpanel } = useChatButton()
  const animate = useChatStore((state) => state.animate)
  const offset = calculateOffset()

  return (
    <S.Button
      $animate={animate.toString()}
      $visible={(!isMobile).toString()}
      dataqaid="Button_NiceChat"
      id="webchat"
      $offsetbottom={offset}
      onClick={() => {
        sendEventOpenChatMixpanel()
      }}
    >
      <S.WrapperIcon>
        <CuraIcon
          name={isMobile ? 'questionCircle' : 'chatCircle'}
          color="neutral-white"
          size={isMobile ? 40 : 32}
        />
      </S.WrapperIcon>
      <S.TextButton>
        {isOpening ? (
          <S.Spinner />
        ) : (
          <CuraLabel size="small" color="neutral-purewhite">
            PRECISA DE AJUDA?
          </CuraLabel>
        )}
      </S.TextButton>
    </S.Button>
  )
}
